import React from 'react';
import { createIcon } from './create-icon';
import './icon-circled-x.scss';

export const IconCircledX = createIcon(<div className="icon-circled-x" />);
